import * as yup from "yup";
import React, { useMemo } from "react";
import { Formik, Form } from "formik";
import { Grid, Button } from "semantic-ui-react";
import { ErrorInfo, FieldRow } from "components/form";
import { validateEmail, usersToSelectOptions } from "services/common";
import { useDispatch } from "react-redux";
import { toast } from "../components/Toast/Toast";

const ApproverForm = ({ approverToUpdate, formClose, users, t }) => {
  const dispatch = useDispatch();
  const isCreateMode = approverToUpdate === null;
  const approverSchema = yup.object().shape({
    name: yup.string().required(t("required")).max(60),
    email: yup.string().required(t("required")).test("is-email", t("invalid_email"), validateEmail),
    user: yup.string().required(t("required")),
  });

  const getApproversUser = () => {
    const approversUser = users.find((user) => user.id === approverToUpdate.userID);
    return approversUser.id;
  };

  const initialValues = useMemo(
    () =>
      !approverToUpdate
        ? {
            name: "",
            email: "",
            user: "",
          }
        : {
            name: approverToUpdate.name,
            email: approverToUpdate.email,
            user: getApproversUser(),
          },
    [approverToUpdate]
  );

  const submitUpdate = (values) => {
    // userID, name, email (requireds)
    const approverCreate = async () => {
      try {
        await dispatch.approvers.create({
          name: values.name,
          email: values.email,
          userID: values.user,
        });
        toast(undefined, t("approver_toast_create_success"));
      } catch (error) {
        console.error(error);
        toast("error", "approver_toast_create_error");
      }
    };
    const approverUpdate = async () => {
      try {
        await dispatch.approvers.update({
          id: approverToUpdate.id,
          name: values.name,
          email: values.email,
          userID: values.user,
        });
        toast(undefined, t("approver_toast_update_success"));
      } catch (error) {
        toast("error", `${t("approver_toast_update_error")}: ${error}`);
      }
    };

    if (isCreateMode) {
      approverCreate();
    } else {
      approverUpdate();
    }

    formClose();
  };

  return (
    <Formik validationSchema={approverSchema} initialValues={initialValues} onSubmit={submitUpdate}>
      {({ errors, isSubmitting, submitCount, values, setFieldValue }) => (
        <Form>
          {/** TODO: Add localization */}
          <h3>{isCreateMode ? "Create Approver" : "Edit Approver"}</h3>
          <Grid columns={1} verticalAlign={"middle"}>
            <FieldRow label={"Approver name"} name="name" />
            <FieldRow label={"Approver email"} name="email" />
            <FieldRow
              search
              label={"AdHub User"}
              name="user"
              placeholder="user"
              onChange={(_e, { value, name }) => {
                setFieldValue(name, value);
              }}
              options={usersToSelectOptions(users)}
              type="select"
            />
          </Grid>
          <ErrorInfo errors={errors} submitCount={submitCount} t={t} tPrefix={""} />

          <div className="form-footer">
            <Button type="button" primary onClick={() => formClose()}>
              {t("cancel")}
            </Button>
            <Button primary type="submit" loading={isSubmitting}>
              {isCreateMode ? t("create") : t("save")}
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default ApproverForm;
